// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"859f5a2d","453":"9a97c7f2","667":"47958404"}[chunkId] + ".chunk.js";
};